import { FC, useEffect, useRef, useState } from "react";
import {
  Paper
} from "@mui/material";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";
import Step4 from "./components/Step4";
import Step5 from "./components/Step5";
import StepperComponent from "./components/Stepper";
import ComplaintComplete from "./components/ComplaintComplete";
import EmailsController from "../../../../Api/emailsController";
import LoadingAnimation from "../../../../components/_common/Loading";
import { useToast } from "../../../../hooks/useToast";

const steps = [
  "Dane kontaktowe",
  "Szczegóły produktu",
  "Opis reklamacji",
  "Zdjęcia",
  "Zgody i podsumowanie"
];

const Form: FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    address: "",
    furnitureName: "",
    furnitureSymbol: "",
    purchaseDate: "",
    purchaseProof: "",
    serialNumber: "",
    defectCircumstances: "",
    defectDescription: "",
    claimType: "",
    consent1: false,
  });
  const [images, setImages] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef<HTMLDivElement>(null);
  const toast = useRef(useToast()).current

  useEffect(() => {
    if (!loading || !loadingRef.current) return;
    const top = loadingRef.current.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: "smooth" });
  }, [loading]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const target = e.target as HTMLInputElement;
    const { name, value, type } = target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? target.checked : value,
    }));
  };

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const res = await EmailsController.sendComplaint({ form, images })
    if (!res.ok) {
      setLoading(false);
      toast.error("Wystąpił błąd podczas wysyłania reklamacji. Spróbuj ponownie później.");
      return;
    }
    setLoading(false);
    handleNext();
  };


  return (
    <Paper
      elevation={6}
      sx={{
        maxWidth: 520,
        mx: "auto",
        mt: 4,
        p: { xs: 2, sm: 4 },
        borderRadius: 4,
        bgcolor: "rgba(255,255,255,0.95)",
        boxShadow: "0 8px 32px 0 rgba(191,161,75,0.15)",
        backdropFilter: "blur(2px)",
      }}
    >
      <StepperComponent
        activeStep={activeStep}
        steps={steps}
      />
      <form onSubmit={handleSubmit}>
        <Step1
          firstName={form.firstName}
          lastName={form.lastName}
          phone={form.phone}
          email={form.email}
          address={form.address}
          handleChange={handleChange}
          handleNext={handleNext}
          activeStep={activeStep}
        />
        <Step2
          activeStep={activeStep}
          furnitureName={form.furnitureName}
          furnitureSymbol={form.furnitureSymbol}
          purchaseDate={form.purchaseDate}
          purchaseProof={form.purchaseProof}
          serialNumber={form.serialNumber}
          handleChange={handleChange}
          handleNext={handleNext}
          handleBack={handleBack}
        />
        <Step3
          activeStep={activeStep}
          defectCircumstances={form.defectCircumstances}
          defectDescription={form.defectDescription}
          claimType={form.claimType}
          handleChange={handleChange}
          handleNext={handleNext}
          handleBack={handleBack}
        />
        <Step4
          activeStep={activeStep}
          images={images}
          setImages={setImages}
          handleNext={handleNext}
          handleBack={handleBack}
        />
        {loading ?
          <div ref={loadingRef}>
            <LoadingAnimation />
          </div>
          :
          <Step5
            activeStep={activeStep}
            form={form}
            images={images}
            handleChange={handleChange}
            handleBack={handleBack}
          />}
      </form>
      {activeStep === steps.length && (
        <ComplaintComplete activeStep={activeStep} />
      )}
    </Paper>
  );
};

export default Form;